var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1004_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.479 328.132L449.783 269.562C448.928 265.118 444.649 261.483 439.943 261.483H347.96C342.827 261.483 338.976 264.714 338.12 269.562L327.425 328.132C324.43 344.693 327.853 361.255 337.265 374.988C348.388 391.146 366.357 400.84 386.465 402.86V467.489C386.465 469.913 384.326 472.336 381.759 472.336L352.667 475.972C350.1 476.376 347.96 478.395 347.96 480.819C347.96 483.647 350.527 485.666 353.094 485.666H433.954C436.949 485.666 439.088 483.243 439.088 480.819C439.088 478.395 436.949 475.972 434.382 475.972L405.717 472.74C403.15 472.336 401.011 470.317 401.011 467.893V403.264C420.691 401.244 438.66 391.146 449.783 375.392C460.051 361.255 463.474 344.693 460.479 328.132ZM415.557 312.783C384.754 310.359 376.197 332.575 343.682 323.285L352.239 276.025H435.665L444.222 322.477C436.949 317.63 427.536 313.59 415.557 312.783Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.971 174.637V150.805H212.338V174.637C212.338 190.39 205.493 205.74 193.086 216.242C180.679 227.148 173.833 242.094 173.833 257.847V473.144C173.833 480.011 179.823 485.666 187.096 485.666H285.068C292.342 485.666 298.331 480.011 298.331 473.144V258.251C298.331 242.498 291.486 227.148 279.079 216.646C266.244 205.74 258.971 190.794 258.971 174.637ZM273.945 423.46C273.945 428.308 270.094 431.943 264.961 431.943H206.776C201.642 431.943 197.792 427.904 197.792 423.46V308.743C197.792 303.896 202.07 300.26 206.776 300.26H264.961C270.094 300.26 273.945 304.3 273.945 308.743V423.46Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.97 109.604C258.97 105.565 255.548 102.333 251.269 102.333H219.61C215.332 102.333 211.909 105.565 211.909 109.604V135.052H258.542L258.97 109.604Z",
    fill: "#FCFCFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(108 94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1004_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 460,
    fill: "white",
    transform: "translate(78 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/alcohol.50f449426b21aab2af24a6b76f4e80f6.svg";
export { ForwardRef as ReactComponent };